import { forwardRef, Ref, useImperativeHandle } from 'react';
import { closeDropper, openDropper } from '../../services/dropper';
import { deepClone } from '../../utils/utils';
import { DropperProps } from './PopoverBody';

export type DropperRefProps = { open: () => void, close: () => void };

function Popover(props: Omit<DropperProps, 'target'> & { targetRef: Ref<HTMLElement> }, imperativeRef: Ref<DropperRefProps>) {
    useImperativeHandle(imperativeRef, () => ({

        open() { const popover = { ...props } as any; popover.target = popover.targetRef.current; console.log(props.targetRef); openDropper(popover as DropperProps); },
        close() { closeDropper(); },
    }));

    return null;
}

export default forwardRef(Popover);